import { combineReducers } from 'redux'
import { spawn } from 'redux-saga/effects'

import {
    reducer as collectionsReducer,
    sagas as collectionsSagas,
} from './collections'

import { reducer as rulesetsReducer, sagas as rulesetsSagas } from './rulesets'
import { reducer as schemasReducer, sagas as schemasSagas } from './schemas'
import {
    reducer as deliverySpecReducer,
    sagas as deliverySpecSagas,
} from './delivery/deliverySpecifications'
import { reducer as refDataReducer, sagas as refDataSagas } from './refData'

import {
    reducer as specificationsReducer,
    sagas as specificationsSagas,
} from './specifications'

import {
    reducer as deliveryConfigReducer,
    sagas as deliveryConfigSagas,
} from './delivery/deliveryConfigs'

import {
    reducer as providersReducer,
    sagas as providersSagas,
} from './providers'

import {
    reducer as regulatorReducer,
    sagas as regulatorSagas,
} from './regulators'
import {
    reducer as submissionsReducer,
    sagas as submissionsSagas,
} from './submissions'

import { reducer as filesReducer, sagas as filesSagas } from './files'

import { reducer as streamReducer, sagas as streamSagas } from './streams'
import { reducer as tokensReducer, sagas as tokensSagas } from './tokens'
import { reducer as appReducer, sagas as appSagas } from './app'
import { sagas as authSagas } from './auth'
import { reducer as userReducer, sagas as userSagas } from './user'
import { reducer as messageAnnouncerReducer } from './messageAnnouncer'
import { reducer as burpReducer, sagas as burpSagas } from './bulk-reprocessing'

export const rootReducer = combineReducers({
    app: appReducer,
    collections: collectionsReducer,
    providers: providersReducer,
    regulators: regulatorReducer,
    rulesets: rulesetsReducer,
    schemas: schemasReducer,
    specifications: specificationsReducer,
    streams: streamReducer,
    deliverySpecs: deliverySpecReducer,
    refDataReducer: refDataReducer,
    deliveryConfig: deliveryConfigReducer,
    tokens: tokensReducer,
    user: userReducer,
    submissions: submissionsReducer,
    files: filesReducer,
    messageAnnouncer: messageAnnouncerReducer,
    bulkReprocessing: burpReducer,
})

export function* rootSaga() {
    yield spawn(collectionsSagas.listen)
    yield spawn(providersSagas.listen)
    yield spawn(regulatorSagas.listen)
    yield spawn(rulesetsSagas.listen)
    yield spawn(schemasSagas.listen)
    yield spawn(specificationsSagas.listen)
    yield spawn(deliverySpecSagas.listen)
    yield spawn(refDataSagas.listen)
    yield spawn(deliveryConfigSagas.listen)
    yield spawn(tokensSagas.listen)
    yield spawn(appSagas.listen)
    yield spawn(authSagas.listen)
    yield spawn(userSagas.listen)
    yield spawn(streamSagas.listen)
    yield spawn(submissionsSagas.listen)
    yield spawn(filesSagas.listen)
    yield spawn(burpSagas.listen)
}
